import { render, staticRenderFns } from "./OutboundTransfersDataTable.template.vue?vue&type=template&id=32711da0&scoped=true&"
var script = {}
import style0 from "./OutboundTransfersDataTable.template.vue?vue&type=style&index=0&id=32711da0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32711da0",
  null
  
)

export default component.exports